// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Ez7","footer":"styles_footer__2FDII","passCodeTooltip":"styles_passCodeTooltip__fCIOh"};